import React, { useEffect, useState } from "react";
import Modal from "../components/Modal";

const Confirmation = ({
  message,
  children,
  onProceed,
  onCancel,
  onDismiss,
  cancelLabel = "Cancel",
  proceedLabel = "Proceed",
  width = "uk-width-auto",
  header,
  dismiss = false,
}) => {
  const [submitting, setSubmitting] = useState(false);

  return (
    <Modal
      className={["uk-padding-small uk-background-muted", width].join(" ")}
    >
      <div className="">
        {header ? <div className="uk-text-large">{header}</div> : null}
        <div className="uk-text-emphasis uk-text-small">
          {message || "This action is not reversible. Do you want to proceed?"}
        </div>
        <hr />
        <div>{children}</div>
        <div
          className=" uk-grid-small uk-child-width-1-2@m uk-flex-center"
          uk-grid={1}
        >
          {dismiss ? (
            <div>
              <button
                type="button"
                className="uk-button uk-width-1-1 uk-button-small uk-button-default uk-text-primary"
                onClick={onDismiss}
              >
                Dismiss
              </button>
            </div>
          ) : (
            <React.Fragment>
              <div>
                <button
                  type="button"
                  className="uk-button uk-width-1-1 uk-button-small uk-button-primary"
                  onClick={onCancel}
                >
                  {cancelLabel}
                </button>
              </div>
              <div>
                <button
                  onClick={async () => {
                    try {
                      await onProceed();
                      setSubmitting(true);
                    } catch (error) {
                      setSubmitting(true);
                    }
                  }}
                  type="button"
                  className="uk-button uk-width-1-1 uk-button-small uk-button-danger"
                  disabled={submitting}
                >
                  {submitting ? (
                    <i className="fa fa-spinner fa-spin fa-fw"></i>
                  ) : (
                    proceedLabel
                  )}
                </button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Confirmation;
